import { lazy } from 'react';

export default [
    {
        path: ['/', '/en'],
        component: lazy(() => import(/* webpackChunkName: 'Home' */ './component')),
    },
];
